"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.from-entries.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.find.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _breakLines = require("../../../utils/breakLines");
var _speakerCardUtils = require("../../speakerCard/speakerCardUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SchedulePage = props => {
  let {
    t,
    title,
    header,
    subheading,
    scheduleData,
    curatorsData,
    speakersData,
    otherPeopleData
  } = props;
  const [activeDay, setActiveDay] = (0, _react.useState)(1);
  const {
    schedules
  } = scheduleData;
  const handleDayClick = day => {
    setActiveDay(day);
  };
  const selectedDay = schedules.find(d => d.day === activeDay);
  const curatorsMap = Object.fromEntries(curatorsData.map(s => [s.speakerId, s]));
  const speakersMap = Object.fromEntries(speakersData.map(s => [s.speakerId, s]));
  const otherPeopleMap = Object.fromEntries(otherPeopleData.map(s => [s.speakerId, s]));
  const getPersonDetails = speaker => {
    switch (speaker.role) {
      case 'curator':
        return curatorsMap[speaker.speakerId];
      case 'speaker':
        return speakersMap[speaker.speakerId];
      case 'other':
        return otherPeopleMap[speaker.speakerId];
      default:
        return null;
    }
  };
  title = title || t('Pages.Schedule.Title');
  header = header || t('Pages.Schedule.Header');
  subheading = subheading || t('Pages.Schedule.Heading');
  (0, _react.useEffect)(() => {
    document.title = title;
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-title-container con-title-container__speakers"
  }, (0, _breakLines.breakLines)(header, 'con-heading con-heading__h3'), (0, _breakLines.breakLines)(subheading, 'con-subtitle con-text con-text__Xtra-larger-regular')), /*#__PURE__*/_react.default.createElement("div", {
    className: "schedule-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "schedule-days-container"
  }, schedules.map(dayObj => /*#__PURE__*/_react.default.createElement("div", {
    key: dayObj.day,
    className: "schedule-days ".concat(activeDay === dayObj.day ? "schedule-days__underline" : "")
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => handleDayClick(dayObj.day),
    className: "schedule-days__day con-text__green-Capital con-text__green-Capital--large con-text__green-Capital--tight con-text__green-Capital--fw400' ".concat(activeDay === dayObj.day ? "" : "schedule-days__day--inactive"),
    "data-text": dayObj.date
  }, dayObj.date)))), /*#__PURE__*/_react.default.createElement("ul", null, selectedDay.events.map((event, index) => {
    var _event$speakers, _event$speakers2, _event$speakers3;
    const firstSpeaker = (_event$speakers = event.speakers) === null || _event$speakers === void 0 ? void 0 : _event$speakers[0];
    const person = firstSpeaker ? getPersonDetails(firstSpeaker) : null;
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "schedule-event",
      key: index
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "con-text__Xtra-larger-SemiBold"
    }, event.time), event.link !== false && person && (firstSpeaker === null || firstSpeaker === void 0 ? void 0 : firstSpeaker.role) !== 'other' && event.abstract && ((_event$speakers2 = event.speakers) === null || _event$speakers2 === void 0 ? void 0 : _event$speakers2.length) === 1 ? /*#__PURE__*/_react.default.createElement("a", {
      href: "/".concat(firstSpeaker.role === 'curator' ? 'curators' : 'speakers', "/").concat((0, _speakerCardUtils.nameToPath)('', person.name), "/").concat(firstSpeaker.speakerId),
      className: "con-heading con-heading__h5 con-heading__h5--small-margin con-heading__h5--underline link-styles__1 link-styles__1--schedule-event"
    }, event.title) : event.link !== false && ((firstSpeaker === null || firstSpeaker === void 0 ? void 0 : firstSpeaker.role) === 'other' || ((_event$speakers3 = event.speakers) === null || _event$speakers3 === void 0 ? void 0 : _event$speakers3.length) > 1 || !event.abstract) ? /*#__PURE__*/_react.default.createElement("p", {
      className: "con-heading con-heading__h5 con-heading__h5--small-margin con-heading__h5--dark-green"
    }, event.title) : /*#__PURE__*/_react.default.createElement("p", {
      className: "con-heading con-heading__h5 con-heading__h5--small-margin"
    }, event.title), event.speakers && /*#__PURE__*/_react.default.createElement("div", {
      className: "margin-top-10"
    }, event.speakers.map((s, i) => {
      const data = getPersonDetails(s);
      if (!data) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "con-text__Xtra-larger-regular",
          key: i
        }, "[No data for speaker", /*#__PURE__*/_react.default.createElement("strong", null, s.speakerId), " \u2013 ", s.role, "]");
      }
      const prefix = s.chair ? 'Chair: ' : '';
      return /*#__PURE__*/_react.default.createElement("p", {
        className: "con-text__Xtra-larger-regular con-text__Xtra-larger-regular--word-space",
        key: i
      }, /*#__PURE__*/_react.default.createElement("b", {
        className: "con-text__Xtra-larger-regular--bold"
      }, prefix), data.name, " | ", data.jobTitle, " | ", data.company);
    })));
  })))));
};
SchedulePage.propTypes = {
  t: _propTypes.default.func,
  title: _propTypes.default.string,
  header: _propTypes.default.string,
  subheading: _propTypes.default.string,
  scheduleData: _propTypes.default.array,
  curatorsData: _propTypes.default.array,
  speakersData: _propTypes.default.array,
  otherPeopleData: _propTypes.default.array
};
var _default = exports.default = SchedulePage;